import { useState } from "react";
import mainStyle from "../../dashboard.module.scss";

import { Box, Grid, Divider } from "@mui/material";

import icn_board_alert from "assets/images/icons/icn_board_alert.svg";
import icn_poe_utilization from 'assets/images/icons/icn_poe_utilization.svg';

const containerStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const valueStyle = {
  color: "#008514",
  fontSize: "35px",
  fontWeight: "600",
};

const separatorStyle = {
  color: "#373737",
  fontSize: "35px",
  fontWeight: "100",
  marginLeft: "5px",
};

const wattValueStyle = {
  color: "#373737",
  fontSize: "35px",
  fontWeight: "600",
  position: "relative",
  display: "inline-block",
  marginLeft: "5px",
};

const wattUnitStyle = {
  position: "absolute",
  bottom: "10px",
  right: "-30px",
  color: "#969696",
  fontSize: "13px",
  fontWeight: "normal",
};

const percentageStyle = {
  color: "#373737",
  fontSize: "35px",
  fontWeight: "600",
  position: "relative",
  display: "flex",
  alignItems: "center",
};

const percentageTextStyle = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  marginTop: "10px",
};

const percentageValueStyle = {
  color: "#373737",
  fontSize: "15px",
  fontWeight: "bold",
  marginLeft: "3px",
};

const consumedTextStyle = {
  color: "#969696",
  fontSize: "13px",
  fontWeight: "normal",
  marginLeft: "5px",
  marginTop: "3px",
};

const dividerStyle = {
  borderColor: "#d5d5d5",
  margin: "15px 20px",
};

const PoEPowerConsumption = ({ sortable, data }) => {
  const [notice, _setNotice] = useState(false);
  const { budget, consumption } = data

  return (
    <div
      style={{}}
      className={`main-card-content ${mainStyle["dndObj_card"]}
        ${notice === true ? mainStyle["dndObj_notice"] : ""}
        ${sortable === true ? mainStyle['dndObj_edit'] : ''}`}
    >
      <div className={mainStyle["dndObj_title"]}>
        <img src={icn_poe_utilization} alt="dashboard_power_icon" />
        <span style={{ marginLeft: "10px" }}>PoE Power Consumption</span>
        {notice && (
          <img alt="dashboard_power_alert"
            src={icn_board_alert}
            style={{ right: "10px", position: "absolute" }}
          />
        )}
      </div>
      <Box style={{ padding: '15px 0px 0px 0px', width: 'auto', height: '165px' }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={containerStyle}
        >
          <Grid item xs={12} style={{ marginTop: "30px" }}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{ position: "relative" }}
            >
              <div style={valueStyle}>{consumption.toFixed(2)}</div>
              <div style={separatorStyle}>/</div>
              <div style={wattValueStyle}>
                {budget}
                <div style={wattUnitStyle}>Watt</div>
              </div>
            </Grid>

            <Divider variant="middle" flexItem sx={dividerStyle} />

            <Grid container justifyContent="center" alignItems="center">
              <div style={percentageStyle}>
                {Number.isFinite(consumption / budget)
                  ? ((consumption / budget) * 100).toFixed(2)
                  : 0}
                <div style={percentageTextStyle}>
                  <div style={percentageValueStyle}>%</div>
                  <div style={consumedTextStyle}>Consumed</div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default PoEPowerConsumption
